const questions = [
  // 1 Слайд \\
  {
    questionText: "สวัสดีครับ ยินดีที่ได้รู้จัก! ผมชื่อสมชาย เป็นนักศึกษา",
    questionDesc:
      "วันนี้เป็นวันหยุด ผมอยากสร้างรายได้จากการขับรถให้ได้มากที่สุด ควรเริ่มจากตรงไหนดี",
    answerOptions: [
      {
        answerText:
          "🚗 ขับไปในตัวเมือง เพราะมีผู้ใช้บริการเยอะ น่าจะมีออเดอร์มาก",
        answerResult:
          "การรอออเดอร์หรือพักผ่อนก็ไม่ใช่เรื่องผิด แต่หากต้องการเพิ่มรายได้ การซื้อแพ็กเกจค่าคอมมิชชัน เป็นตัวเลือกที่คุ้มค่ากว่า เลือกได้ทั้ง 3, 6, 10 หรือ 24 ชั่วโมง รับเงินจากออเดอร์ได้เต็มจำนวนจนกว่าแพ็กเกจจะหมดอายุ",
        result: false,
      },
      {
        answerText: "💰 ซื้อแพ็กเกจค่าคอมมิชชันแบบรายชั่วโมง",
        answerResult:
          "การรอออเดอร์หรือพักผ่อนก็ไม่ใช่เรื่องผิด แต่หากต้องการเพิ่มรายได้ การซื้อแพ็กเกจค่าคอมมิชชัน เป็นตัวเลือกที่คุ้มค่ากว่า เลือกได้ทั้ง 3, 6, 10 หรือ 24 ชั่วโมง รับเงินจากออเดอร์ได้เต็มจำนวนจนกว่าแพ็กเกจจะหมดอายุ",
        result: true,
      },
      {
        answerText: "😴 ยังไม่รู้จะทำอะไร งั้นขอนอนก่อนแล้วกัน",
        answerResult:
          "การรอออเดอร์หรือพักผ่อนก็ไม่ใช่เรื่องผิด แต่หากต้องการเพิ่มรายได้ การซื้อแพ็กเกจค่าคอมมิชชัน เป็นตัวเลือกที่คุ้มค่ากว่า เลือกได้ทั้ง 3, 6, 10 หรือ 24 ชั่วโมง รับเงินจากออเดอร์ได้เต็มจำนวนจนกว่าแพ็กเกจจะหมดอายุ",
        result: false,
      },
    ],
    image: "images/1.png",
  },

  // 2 слайд \\
  {
    questionText:
      "ขอบคุณสำหรับคำแนะนำนะ! ตอนนี้ผมซื้อแพ็กเกจค่าคอมมิชชันแบบ 6 ชั่วโมงมาเรียบร้อยแล้ว กะว่าจะหาเงินเพิ่มสักหน่อย... แล้วไงต่อดีล่ะ",
    answerOptions: [
      {
        answerText: "แวะจิบกาแฟก่อน! ขอเติมพลังให้พร้อมก่อนเริ่มกะ",
        answerResult:
          "⏰ ซื้อแพ็กเกจแล้ว เวลาเริ่มนับถอยหลังทันที! แนะนำว่าอย่ารอช้า รีบกดเปิดรับออเดอร์เพื่อความคุ้มค่าสูงสุดกันเลย!",
        result: false,
      },
      {
        answerText: "กดรับออเดอร์ทันที! เวลาเดินไว ต้องรีบโกย",
        answerResult:
          "⏰ ซื้อแพ็กเกจแล้ว เวลาเริ่มนับถอยหลังทันที! แนะนำว่าอย่ารอช้า รีบกดเปิดรับออเดอร์เพื่อความคุ้มค่าสูงสุดกันเลย!",
        result: true,
      },
      {
        answerText:
          "เวลาเหลือ ๆ แวะจัดการธุระส่วนตัวไปด้วย รับงานไปด้วยได้ชิล ๆ",
        answerResult:
          "⏰ ซื้อแพ็กเกจแล้ว เวลาเริ่มนับถอยหลังทันที! แนะนำว่าอย่ารอช้า รีบกดเปิดรับออเดอร์เพื่อความคุ้มค่าสูงสุดกันเลย!",
        result: false,
      },
    ],
    image: "images/2.png",
  },

  // 3 слайд \\
  {
    questionText:
      "มีทั้งรถยนต์และมอเตอร์ไซค์จอดอยู่บ้าน... เลือกรถคันไหนมาวิ่งรับออเดอร์ให้สร้างรายได้ปังที่สุดดีนะ",
    answerOptions: [
      {
        answerText: "มอเตอร์ไซค์: คล่องตัว คล่องแคล่ว ถึงไว",
        answerResult:
          "ไม่ว่าจะขับรถประเภทไหน ก็สร้างรายได้สุดคุ้มกับเรา! จ่ายครั้งเดียวจบ ไม่ต้องกังวลเรื่องค่าคอมมิชชันหรือภาษีมูลค่าเพิ่ม (VAT) ด้วยแพ็กเกจค่าคอมฯ ที่ช่วยให้คุณวางแผนและควบคุมค่าใช้จ่ายได้ดียิ่งขึ้น",
        result: false,
      },
      {
        answerText: "รถยนต์: นั่งสบาย พร้อมให้บริการรับ-ส่งผู้โดยสาร",
        answerResult:
          "ไม่ว่าจะขับรถประเภทไหน ก็สร้างรายได้สุดคุ้มกับเรา! จ่ายครั้งเดียวจบ ไม่ต้องกังวลเรื่องค่าคอมมิชชันหรือภาษีมูลค่าเพิ่ม (VAT) ด้วยแพ็กเกจค่าคอมฯ ที่ช่วยให้คุณวางแผนและควบคุมค่าใช้จ่ายได้ดียิ่งขึ้น",
        result: false,
      },
      {
        answerText: "คันไหนก็ทำเงินได้ทั้งนั้น!",
        answerResult:
          "ไม่ว่าจะขับรถประเภทไหน ก็สร้างรายได้สุดคุ้มกับเรา! จ่ายครั้งเดียวจบ ไม่ต้องกังวลเรื่องค่าคอมมิชชันหรือภาษีมูลค่าเพิ่ม (VAT) ด้วยแพ็กเกจค่าคอมฯ ที่ช่วยให้คุณวางแผนและควบคุมค่าใช้จ่ายได้ดียิ่งขึ้น",
        result: true,
      },
    ],
    image: "images/3.png",
  },

  // 4 слайд \\
  {
    questionText:
      "อุ๊ย! วันนี้พ่อของผมขับรถยนต์ออกไปข้างนอกซะแล้ว... แต่ไม่เป็นไร! วันนี้เปลี่ยนแผนมารับออเดอร์ด้วยมอเตอร์ไซค์แทนก็ได้ ",
    questionDesc:
      "แต่เอ๊ะ... แอบกังวลนิดหน่อย ผู้โดยสารจะรู้ได้ยังไงนะว่าเราคือคนขับจาก Maxim",
    answerOptions: [
      {
        answerText: "ตะโกนคำว่า «MAXIM!!» ลั่นถนน พร้อมโบกมือรัว ๆ",
        answerResult:
          "แต่งหล่อพร้อมรับงาน! สวมเครื่องแบบเพื่อสร้างความมั่นใจ ส่วนพาร์ทเนอร์รถยนต์ก็สามารถติดสติกเกอร์โฆษณา Maxim บนรถ เพื่อช่วยให้ผู้โดยสารมองเห็นและจดจำได้ง่ายยิ่งขึ้น",
        result: false,
      },
      {
        answerText: "ไม่ต้องทำอะไรเลย ปล่อยให้ผู้โดยสารมองหาเราในแผนที่เอง",
        answerResult:
          "แต่งหล่อพร้อมรับงาน! สวมเครื่องแบบเพื่อสร้างความมั่นใจ ส่วนพาร์ทเนอร์รถยนต์ก็สามารถติดสติกเกอร์โฆษณา Maxim บนรถ เพื่อช่วยให้ผู้โดยสารมองเห็นและจดจำได้ง่ายยิ่งขึ้น",
        result: false,
      },
      {
        answerText: "สวม เสื้อกั๊ก Maxim ออกรับงานอย่างมั่นใจ!",
        answerResult:
          "แต่งหล่อพร้อมรับงาน! สวมเครื่องแบบเพื่อสร้างความมั่นใจ ส่วนพาร์ทเนอร์รถยนต์ก็สามารถติดสติกเกอร์โฆษณา Maxim บนรถ เพื่อช่วยให้ผู้โดยสารมองเห็นและจดจำได้ง่ายยิ่งขึ้น",
        result: true,
      },
    ],
    image: "images/4.png",
  },

  // 5 слайд \\ Бандана [2]
  {
    questionText: "ออเดอร์แรกมาแล้ว ได้เวลารับงาน! มีอะไรอยากฝากบอกผมไหม",
    answerOptions: [
      {
        answerText: "ขอให้ประสบความสำเร็จ! ",
        answerResult: "ความปลอดภัยของผู้โดยสารคือสิ่งสำคัญที่สุด ขอให้โชคดี",
        result: false,
      },
      {
        answerText:
          "ขับขี่ปลอดภัย! แล้วอย่าลืมเตือนผู้โดยสารสวมหมวกกันน็อกด้วยล่ะ",
        answerResult: "ความปลอดภัยของผู้โดยสารคือสิ่งสำคัญที่สุด ขอให้โชคดี",
        result: true,
      },
      {
        answerText: "ขอให้เดินทางปลอดภัย รับงานปัง ๆ กำไรงาม ๆ",
        answerResult: "ความปลอดภัยของผู้โดยสารคือสิ่งสำคัญที่สุด ขอให้โชคดี",
        result: false,
      },
    ],
    image: "images/5.png",
  },
];

export default questions;
